function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.7 13.632a3.068 3.068 0 0 1 .36-1.044 2.1 2.1 0 0 1 .708-.744 2.13 2.13 0 0 1 1.092-.276 2.175 2.175 0 0 1 .756.156 1.935 1.935 0 0 1 .624.432 2.311 2.311 0 0 1 .408.636 2.1 2.1 0 0 1 .168.768h2.144a4.3 4.3 0 0 0-.336-1.548 3.6 3.6 0 0 0-.84-1.212 3.919 3.919 0 0 0-1.3-.792 4.635 4.635 0 0 0-1.668-.276 4.69 4.69 0 0 0-2.04.408 4.127 4.127 0 0 0-1.44 1.1 4.511 4.511 0 0 0-.852 1.632 7.028 7.028 0 0 0-.288 1.968v.324a7.026 7.026 0 0 0 .276 1.968 4.362 4.362 0 0 0 .852 1.62 4.1 4.1 0 0 0 1.44 1.092 4.869 4.869 0 0 0 2.04.408 4.577 4.577 0 0 0 1.584-.276 4.093 4.093 0 0 0 1.3-.756 3.663 3.663 0 0 0 .888-1.128 3.23 3.23 0 0 0 .36-1.38h-2.148a1.708 1.708 0 0 1-.18.7 1.766 1.766 0 0 1-.432.552 1.89 1.89 0 0 1-.624.36 2.383 2.383 0 0 1-.72.12 2.038 2.038 0 0 1-1.068-.276 2.1 2.1 0 0 1-.708-.744 3.136 3.136 0 0 1-.36-1.056 8.088 8.088 0 0 1-.1-1.2v-.324a8 8 0 0 1 .1-1.212zM15 3a12 12 0 1 0 12 12A12 12 0 0 0 15 3zm0 21.6a9.6 9.6 0 1 1 9.6-9.6 9.613 9.613 0 0 1-9.6 9.6z",
    transform: "translate(-3 -3)",
    style: {
      fill: "#204bf8"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyright);
export default __webpack_public_path__ + "static/media/copyright.2427d8d51bf9f586367ee6050864c517.svg";
export { ForwardRef as ReactComponent };